import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
export const UTMTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    UTM_KEYS.forEach((param) => {
      const value = searchParams.get(param);
      try {
        if (value) localStorage.setItem(param, value);
      } catch (error) {
        console.error(`Failed to set data in localStorage:`, error);
      }
    });
  }, [location.search]);

  return null;
};

export const useUTMParams = () => {
  const get = () => {
    const utm: Record<string, string> = {};
    try {
      UTM_KEYS.forEach((key) => {
        const val = localStorage.getItem(key);
        if (val) {
          utm[key] = val;
        }
      });
    } catch (error) {
      console.error(`Error accessing localStorage":`, error);
    }
    return utm;
  };
  const clear = () => {
    try {
      UTM_KEYS.forEach((key) => localStorage.removeItem(key));
    } catch (error) {
      console.error(`Failed to remove localStorage:`, error);
    }
  };

  return { clear, get };
};
